import React__default, { createContext, useContext } from 'react';
import { useConversationState } from './hooks/useConversationState.js';

const ConciergeContext = createContext(undefined);
const useConciergeContext = () => {
    const context = useContext(ConciergeContext);
    if (!context) {
        throw new Error("useConciergeContext must be used within ConciergeContextProvider");
    }
    return context;
};
const ConciergeContextProvider = ({ children, apiBaseUrl }) => {
    const conversationState = useConversationState();
    return (React__default.createElement(ConciergeContext.Provider, { value: Object.assign(Object.assign({}, conversationState), { apiBaseUrl }) }, children));
};

export { ConciergeContextProvider, useConciergeContext };
//# sourceMappingURL=ConciergeContextProvider.js.map
